import React from 'react';

import { Button, TextField, MenuItem, Tooltip, Paper, Select, OutlinedInput } from '@material-ui/core';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import DriverQueueInfo from '../../../models/DriverQueueInfo';

import commonStyles from '../../common/common.module.css';
import driverStyle from './driverQueue.module.css';

import fdLogo from '../../../assets/fd_text_logo.png';
import AirlineType from '../../../models/AirlineType';
import GhaDock from '../../../models/GhaDock';

const styles = (theme: Theme) =>

  createStyles({
    overrideBorder: {
      border: '1px solid var(--primaryblue)', 
    },
    driverInput: {
      '&:hover': {
        outline: '1px solid var(--primaryblue)',
        borderRadius: '4px'
      }
    },
    menuItem: {
      fontSize: '14px',
      minHeight: '34px'
    }
  });

interface DriverQueuePageProps {
  classes: any;
  info: DriverQueueInfo;
  ghaName: string;
  handleChange: (fieldName: string, event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSave: (type: string) => void;
  disabledButton: boolean;
  docks: GhaDock[];
  airlines: Array<AirlineType>;
  changeScreen: Function;
  buttonState: boolean;
  mandatoryFields: Array<string>;
};

const driverQueuePage = (props: DriverQueuePageProps) => {

  const { classes } = props;

  const isFieldRequired = (fieldName: string) => {
    return props.mandatoryFields.includes(fieldName);
  };

  const docks = props.docks.map((dock: GhaDock, index: number) => {
    return (
      <MenuItem key={index} value={dock.name} className={classes.menuItem}>{dock.name}</MenuItem>
    )
  });

  const airlines = props.airlines.map((option: AirlineType, index: number) => {
    return (
      <MenuItem key={ index } value={ option.iata_code } className={ classes.menuItem }>{ option.name }</MenuItem>
    )
  })

  return (
    <div className={ driverStyle.pageWrapper }>
      <div className={ driverStyle.logoWrapper }>
        <img alt="frontline dynamics logo" src={fdLogo} className={ driverStyle.logoImg } />
        <div className={ driverStyle.ghaName }>{ props.ghaName } </div>
      </div>

      <div className={ driverStyle.content }>

        <div className={` ${ driverStyle.inputLabelWrapper } ${ commonStyles.mb3 } `}>
          <label className={ driverStyle.inputLabel }> First Name </label>
          <TextField
            label=""
            variant="outlined"
            InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
            value={ props.info.first_name }
            onChange={ (event: React.ChangeEvent<HTMLInputElement>) => props.handleChange('firstName', event) }
            className={ classes.driverInput }
          />
        </div>
        <div className={` ${ driverStyle.inputLabelWrapper } ${ commonStyles.mb3 } `}>
          <label className={driverStyle.inputLabel}> Last Name </label>
          <TextField
            label=""
            variant="outlined"
            value={ props.info.last_name }
            onChange={ (event: React.ChangeEvent<HTMLInputElement>) => props.handleChange('lastName', event) }
            InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
            className={ classes.driverInput }
          />
        </div>
        <div className={` ${ driverStyle.inputLabelWrapper } ${ commonStyles.mb3 } `}>
          <label className={ driverStyle.inputLabel }> Company name </label>
          <TextField
            label=""
            variant="outlined"
            value={ props.info.company } 
            onChange={ (event: React.ChangeEvent<HTMLInputElement>) => props.handleChange('company', event) }
            InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
            className={ classes.driverInput }
          />
        </div>
        <div className={` ${ driverStyle.inputLabelWrapper } ${ commonStyles.mb3 } `}>
          <label className={ driverStyle.inputLabel }> Select </label>
          <Select
            variant="outlined"
            className={ classes.overrideBorder }
            value={ props.info.type }
            onChange={(event: any) => props.handleChange('type', event)}
          >
            <MenuItem value='import' className={ classes.menuItem }>Pick Up</MenuItem>
            <MenuItem value='export' className={ classes.menuItem }>Drop Off</MenuItem>
          </Select>
        </div>
        <div className={` ${ driverStyle.inputLabelWrapper } ${ commonStyles.mb3 } `}>
          <label className={ driverStyle.inputLabel }> {`${ isFieldRequired('airlines') ? '' : 'Optional - '}Select Airline `}</label>
          <Select
            variant="outlined"
            className={ classes.overrideBorder }
            multiple
            value={ props.info.airlines }
            onChange={(event: any) => props.handleChange('airline', event)}
            required={isFieldRequired('airlines')}
          >
            { airlines }
          </Select>
        </div>
        <div className={` ${ driverStyle.inputLabelWrapper } ${ commonStyles.mb3 } `}>
          <label className={ driverStyle.inputLabel }> Optional - Select Dock </label>
          <Select
            variant="outlined"
            className={ classes.overrideBorder }
            value={ props.info.dock }
            onChange={(event: any) => props.handleChange('dock', event)}
          >
            { docks } 
          </Select>
        </div>

        <div className={` ${ driverStyle.inputLabelWrapper } ${ commonStyles.mb3 } `}>
          <label className={ driverStyle.inputLabel }> Optional - Remarks </label>
          <TextField
            label=""
            variant="outlined"
            value={ props.info.remarks } 
            onChange={ (event: React.ChangeEvent<HTMLInputElement>) => props.handleChange('remarks', event) }
            InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
            className={ classes.driverInput }
          />
        </div>
      </div>

      <div className={ `${ driverStyle.footer } ${ commonStyles.fSpaceBtw }` }>
        <Button 
          color="secondary" 
          variant="contained"
          className={`${ driverStyle.button } ${ driverStyle.redButton }`}
          onClick={ () => props.changeScreen('home') }
        > 
         Go Back
        </Button>
        <Button
          color="primary"
          variant="contained"
          className={ driverStyle.button }
          onClick={ () => props.handleSave('walk_in') }
          disabled={ props.disabledButton || props.buttonState }
        >
          Check In
        </Button>
      </div>

    </div>
  );
}

export default withStyles(styles)(driverQueuePage);